import React, { useState } from 'react';
import Card from '../layout/Card';
import { useSocket } from '../Context/SocketContext';
import BtnStandard from '../components/BtnStandard';
import { infoUser } from '../utils/auth';

const WidgetSendNotif = ({ label, icone, sign = "" }) => {
    const { priceEmpire, setPriceEmpire, socket } = useSocket()
    const [msg, setMsg] = useState("")
    const [link, setLink] = useState("")
    const [linkLabel, setLinkLabel] = useState("")
    const [select, setSelect] = useState("all")
    const [openUser, setOpenUser] = useState(false)
    const targetUser = [
        { value: "all", label: "Tout le monde" },
        { value: "user_account_less", label: "User Compte sans Abo" },
        { value: "user_account", label: "User Compte + premium" },
        { value: "user_no_account", label: "User Sans compte" },
        { value: "user_premium", label: "User en premium" }
    ]
    const [load, setLoad] = useState(false)
    const userToken = infoUser()
    const handleSend = async () => {
        if (!load) {
            setLoad(true)
            const response = await new Promise((resolve, reject) => {
                socket.emit('empire_send_notif_mainpage', {
                    token: userToken.expecttoken,
                    message: msg,
                    target: select,
                    linkLabel: linkLabel,
                    link: link
                }, (e) => resolve(e))
            })
            if (response) {

            }
            setLoad(false)
        }
    }
    return (
        <Card>
            <button onClick={() => { }} className='df aic'>
                <div className='mr3 px1 py1 df aic jcc bcb jc' style={{ borderRadius: "50%" }}  >
                    {icone && (
                        <img style={{ height: "30px", width: "30px", objectFit: "contain" }} src={icone} alt="logo" srcset="" />
                    )}
                    {!icone && sign && <p style={{ height: "30px", width: "30px" }} className='fb df aic jcc cw'>{sign}</p>}
                </div>
                <div>
                    <p className='fl tal cw fs12'>{label}</p>
                    <input placeholder='Votre message' value={msg} onChange={(v) => setMsg(v.currentTarget.value)} className='field-input fr cw py1' />
                    <input placeholder='Label Lien *optionnel ' value={linkLabel} onChange={(v) => setLinkLabel(v.currentTarget.value)} className='field-input fr cw py1' />
                    <input placeholder='Lien *optionnel ' value={link} onChange={(v) => setLink(v.currentTarget.value)} className='field-input fr cw py1' />
                    {openUser && (
                        <div className='df fw gap1'>
                            {targetUser.map((t, i) => (
                                <button key={i + "_slct_nnotif_user"} onClick={() => setSelect(t.value)} className={`btn tal ${t?.value == select ? "cs" : "cw"} `}>{t.label}</button>
                            ))}
                        </div>
                    )}
                    <div className='df fdc gap1'>

                        <BtnStandard size='s' label={"Cible"} load={load} click={() => setOpenUser(!openUser)} />
                        {select && msg && (
                            <BtnStandard size='s' label={"Envoyer"} load={load} click={() => handleSend()} />
                        )}
                    </div>
                </div>
            </button>
        </Card>
    );
};

export default WidgetSendNotif;